export interface Buyer {
  email: string;
  phone: string;
  last_name: string;
  first_name: string;
  language: string;
  birthday?: Date;
}
